import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Stack,
  Button,
  Divider,
  Typography,
  IconButton,
  alpha,
} from '@mui/material';
import Iconify from '../common/iconify.component';
import Scrollbar from '../common/scrollbar.component';
import CollapsibleSection from './collapsible-section.component';
import FilterInputCondition from './filter-input-condition.component';
import MultiValueInputCondition from './multi-value-input.component';
import DateBetweenInput from './date-between-input.component';
import useResponsive from '../../hooks/responsive.hook';

const DistributorFilterVideos = ({
  values,
  onCancel,
  onSuccess,
  onClear,
  from,
}) => {
  const isDesktop = useResponsive('up', 'lg');

  const [filters, setFilters] = useState(values || {});

  useEffect(() => {
    setFilters(values || {});
  }, [values]);

  const handleApplyFilters = () => {
    onSuccess(filters);
  };

  return (
    <>
      <Stack
        direction="row"
        alignItems="center"
        sx={{
          px: 1,
          py: 2,
          // eslint-disable-next-line no-nested-ternary
          minHeight: !isDesktop
            ? '76px'
            : from !== 'video-assignment' && from !== 'edit-videos-list'
            ? '92px'
            : '60px',
        }}
      >
        <Typography variant="subtitle1" sx={{ ml: 1, textAlign: 'center' }}>
          Filters
        </Typography>
        {from !== 'video-assignment' && from !== 'edit-videos-list' && (
          <IconButton
            color="inherit"
            variant="contained"
            sx={{
              marginLeft: 2,
              borderRadius: '100%',
              width: 'auto',
              padding: '8px',
              bgcolor: (theme) => alpha(theme.palette.grey[400], 1),
              '&:hover': {
                bgcolor: (theme) => alpha(theme.palette.grey[400], 1),
                boxShadow: 'none',
              },
            }}
            onClick={onCancel}
          >
            <Iconify icon="mdi:menu-close" />
          </IconButton>
        )}
      </Stack>

      <Divider sx={{ borderStyle: 'dashed' }} />

      <Scrollbar
        sx={{
          '& .simplebar-content': {
            height: 1,
            display: 'flex',
            flexDirection: 'column',
          },
        }}
      >
        <form id="list-data-filters" onSubmit={(e) => e.preventDefault()}>
          <Stack sx={{ p: 2 }}>
            <CollapsibleSection
              id="title_name_only"
              title="Title"
              subSection
              filters={filters}
              setFilters={setFilters}
              initiallyExpand
            >
              <FilterInputCondition
                id="title_name_only"
                name="titleSearch"
                filters={filters}
                setFilters={setFilters}
                title="Title"
                fromDistributorFilter
              />
            </CollapsibleSection>
            <CollapsibleSection
              title="Date Added"
              id="date_creation"
              subSection
              filters={filters}
              setFilters={setFilters}
            >
              <DateBetweenInput
                id="date_creation"
                name="dateAdded"
                filters={filters}
                setFilters={setFilters}
                title="Date Added"
                fromDistributorFilter
              />
            </CollapsibleSection>
            <CollapsibleSection
              title="SKU"
              id="distributor_sku"
              subSection
              filters={filters}
              setFilters={setFilters}
            >
              <MultiValueInputCondition
                id="distributor_sku"
                name="distributor_sku"
                filters={filters}
                setFilters={setFilters}
                title="SKU"
                fromDistributorFilter
              />
            </CollapsibleSection>
            <CollapsibleSection
              title="Date License Expiration"
              id="date_license_expiration"
              subSection
              filters={filters}
              setFilters={setFilters}
              sx={{
                borderBottom: 1,
                borderWidth: '1px',
                borderColor: 'gray',
              }}
            >
              <DateBetweenInput
                id="date_license_expiration"
                name="dateLicenseExpire"
                filters={filters}
                setFilters={setFilters}
                title="Date License Expiration"
                fromDistributorFilter
              />
            </CollapsibleSection>
          </Stack>
        </form>
      </Scrollbar>
      <Divider />

      <Stack spacing={1} sx={{ p: 2, flex: 1 }}>
        <Button
          fullWidth
          form="list-data-filters"
          type="submit"
          color="primary"
          variant="contained"
          onClick={handleApplyFilters}
        >
          Apply Filters
        </Button>
        <Button
          fullWidth
          type="button"
          color="secondary"
          variant="contained"
          startIcon={<Iconify icon="ic:round-clear-all" />}
          onClick={onClear}
        >
          Clear All
        </Button>
      </Stack>
    </>
  );
};

DistributorFilterVideos.propTypes = {
  values: PropTypes.shape().isRequired,
  onCancel: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  from: PropTypes.string,
};

DistributorFilterVideos.defaultProps = {
  from: '',
};

export default DistributorFilterVideos;
